import React from "react";
import { Modal } from "reactstrap";
import AppButton from "components/app-button";

const SessionExpiredModal = ({ isOpen, inactiveDuration, onOk }) => {
    return (
        <Modal
            isOpen={isOpen}
            className="app-confirmation-modal"
            contentClassName="app-confirmation-modal__content"
        >
            <div className="app-confirmation-modal__label">
                You have been inactive for <b>{inactiveDuration}</b>. Your session has ended.
            </div>
            <div className="app-confirmation-modal__buttons-row">
                <div className="app-confirmation-modal__button-wrapper">
                    <AppButton colorType="orange" label="OK" onClick={onOk} />
                </div>
            </div>
        </Modal>
    );
};

export default SessionExpiredModal;
